export function debounce (f, ms) {
  let isCooldown = false
  let args = []

  return function () {
    args = arguments
    if (isCooldown) return

    f.apply(this, args)

    isCooldown = true

    setTimeout(() => {
      isCooldown = false
      f.apply(this, args)
    }, ms)
  }
}
